import { Box, getVariant } from '@apia/theme';
import UploaderApi from '../../../../common/uploader/UploaderApi';
import { TDocType } from '../../../../common/uploader/types';
import { parseAsSize } from '@apia/util';
import { getLabel } from '../../../../../utils/util';

export type DocTypeInfo = {
  extensions: string[];
  id: string;
  maxSize: number;
  label: string;
};

function addDocTypeInfoToArray(arr: DocTypeInfo[], docType: TDocType) {
  arr.push({
    extensions: buildExtensionsArray(docType.docExts),
    id: docType.id,
    label: docType.title,
    maxSize: docType.maxSize,
  });
}

function buildExtensionsArray(ext: string) {
  return (ext ?? '')
    .split(';')
    .filter((current) => current !== '')
    .map((current) => `.${current}`);
}

function getTooltipsToShow(api: UploaderApi) {
  try {
    const hasOneClickUpload = api.configurationObject.oneClickUpload;
    const docTypes = api.getStore().allowedTypes;

    const docTypesInfo: DocTypeInfo[] = [];

    if (hasOneClickUpload) {
      const generic = docTypes.find((c) => String(c.id) === '1');
      if (generic) {
        addDocTypeInfoToArray(docTypesInfo, generic);
      } else {
        const docType = docTypes[0];
        addDocTypeInfoToArray(docTypesInfo, docType);
      }
    } else {
      const hasAssociatedTypes = api.getValidationStore().allDocTypes === false;

      if (hasAssociatedTypes) {
        docTypes.forEach((docType) => {
          addDocTypeInfoToArray(docTypesInfo, docType);
        });
      } else {
        const generic = docTypes.find((c) => String(c.id) === '1');
        addDocTypeInfoToArray(docTypesInfo, generic!);
      }
    }

    return docTypesInfo;
  } catch (e) {
    e;
    return [];
  }
}

export default function makeDocTypeTooltip(
  api: UploaderApi,
  docTypes?: DocTypeInfo[],
) {
  const docTypesInfo = docTypes || getTooltipsToShow(api);

  return (
    <Box
      className="docTypes__tooltipWrapper"
      {...getVariant('layout.execution.components.uploader.tooltip')}
    >
      {docTypesInfo.map((currentDocType) => (
        <Box key={currentDocType.id}>
          <Box className="head" as="strong">
            {currentDocType.label}{' '}
          </Box>
          <Box>
            <Box as="strong">{window.LBL_ALLOWED_EXTENSIONS} </Box>
            <Box as="span">
              {currentDocType.extensions.length > 0
                ? currentDocType.extensions.join(', ')
                : getLabel('lblAllDcTypeAcc').text}
              .
            </Box>
          </Box>
          <Box>
            <Box as="strong">{window.LBL_MAX_SIZE} </Box>
            <Box as="span">{parseAsSize(currentDocType.maxSize)}</Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export function makeDocTypeDescription(currentDocType: TDocType) {
  return currentDocType
    ? `${currentDocType.title} ${window.LBL_ALLOWED_EXTENSIONS} ${
        (currentDocType.docExts ?? '') !== ''
          ? (currentDocType.docExts ?? '')
              .split(';')
              .filter((current) => current !== '')
              .map((current) => `.${current}`)
              .join(', ')
          : window.MSG_ALL_DC_TYPE_ACCEPTED
      } ${window.LBL_MAX_SIZE} ${parseAsSize(currentDocType.maxSize)}`
    : '';
}
